import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { InvoiceTransactionLinkSearchModel } from 'src/app/shared/models/domain/invoice-transaction-link-search.model';
import { InvoiceTransactionLinkModel } from 'src/app/shared/models/domain/invoice-transaction-link.model';
import { InvoicePaymentSearchModel } from 'src/app/shared/models/domain/invoice-payment-search.model';
import { InvoicePaymentModel } from 'src/app/shared/models/domain/invoice-payment.model';

@Injectable()
export class InvoicePaymentService {
  private url = environment.apiUrl + '/invoice-payments/';

  constructor(private http: HttpClient) {
  }

  search(searchModel: InvoicePaymentSearchModel): Observable<InvoicePaymentModel[]> {
    return this.http.post<InvoicePaymentModel[]>(this.url + 'search', searchModel);
  }

  create(model: InvoicePaymentModel): Observable<string> {
    return this.http.post<string>(this.url, model);
  }

  update(model: InvoicePaymentModel): Observable<boolean> {
    return this.http.put<boolean>(this.url, model);
  }

  delete(key: string): Observable<boolean> {
    return this.http.delete<boolean>(this.url + key);
  }
}
